// controls display of elements based on radio button selection, sort of like tabs

const radioSwitchListsAll = document.querySelectorAll("._jsRadioSwitchList");

// for each list..

radioSwitchListsAll.forEach(radioSwitchList => {

	// get list id

	const listId = radioSwitchList.getAttribute("id");

	// get all radiobuttons in list

	const radioSwitches = radioSwitchList.querySelectorAll("input");

	// for each radiobutton..

	radioSwitches.forEach(radioSwitch => {

		// get radiobutton target

		const targetId = radioSwitch.getAttribute("aria-controls");
		const target = document.getElementById(targetId);

		// set listId as attribute on each target to control them as a group

		target.setAttribute("data-switchableGroup", listId);

		// listen for change on radiobutton

		radioSwitch.addEventListener("change", function() {

			// get all group targets based on added listId attribute

			const targetGroup = document.querySelectorAll("[data-switchableGroup=" + listId + "]");

			// close each target, then open desired one

			targetGroup.forEach(eachTarget => {
				eachTarget.classList.remove("open");
				target.classList.add("open");
			});
		});
	});
});
